import qs from 'qs'

function parseParams(queryString) {
  return qs.parse(queryString, { arrayLimit: 50, ignoreQueryPrefix: true })
}

function stringifyParams(filters, opts = {}) {
  return qs.stringify(filters, { encodeValuesOnly: true, arrayFormat: 'indices', ...opts })
}

function updateParams(params, history) {
  history.push({
    search: stringifyParams(params),
  })
}

export { parseParams, stringifyParams, updateParams }
